import React from 'react';
import axios from 'axios';
import ProductCard from '../components/productCard';
import FilterItem from '../components/filterItem';
import ReactPaginate from 'react-paginate';
import { scroller } from 'react-scroll'
import queryString from 'query-string'

class Products extends React.Component {
  state = {
    products: [],
    loading: true,
    acf: null,
    filters: null,
    totalProducts: null,
    forcePage: 1,
    activePage: 1,
    totalPages: 1,
    totalItemsCount: null,
    currentFilter: null,
    filterClicked: false,
    firedoor: false,
    mobileFilters: false,
    showMoibleFilters: false,
  }


  componentDidMount() {
    axios.get(`${window.wpApiSettings.root}wp/v2/pages/${window.productsPage}`)
      .then(res => {
        const acf = res.data.acf.page_components;
        const content = res.data.content.rendered
        this.setState({ acf, content });
      })

    const values = queryString.parse(this.props.location.search)

    this.getFilters()

    window.addEventListener('scroll', this.toggleMobileFilters)

    if (values.type && values.productPage) {
      this.setState({ activePage: values.productPage - 1, currentFilter: values.type }, () => {
      this.filterProducts(values.type);
      // console.log(this.state.currentFilter)
      })
    } else if(values.type) {
      this.setState({ currentFilter: values.type }, () => {
        this.filterProducts(values.type);
        // console.log(this.state.currentFilter)
      })
    } else if (values.productPage) {

      this.setState({ activePage: values.productPage - 1 }, () =>
      this.getProducts())
    }
     else {
      this.getProducts()
    }
    document.title = `Doors - Masonite`
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.toggleMobileFilters)
  }

  toggleMobileFilters = () => {
    if(document.documentElement.clientWidth < 768) {
      const productsContainer = document.getElementsByClassName('products-container')[0]
      let scrollPostion = window.scrollY;
      if(scrollPostion >= productsContainer.offsetTop && scrollPostion <= productsContainer.offsetHeight) {
        this.setState({ showMoibleFilters: true })
      } else {
        this.setState({ showMoibleFilters: false })
      }
    }
  }

  getFilters = () => {
    this.setState({ loading: true, currentFilter: null });
    let getProductsURL = encodeURI(`${window.wpApiSettings.root}api/get-products-and-filters/?group-by=name&basic=true`);
    axios.get(getProductsURL)
      .then(res => {
        const data = res.data.body;
        this.setState({
          filters: data.basicFilters,
        });
      })
  }

  getProducts = () => {
    this.setState({ loading: true, currentFilter: null });
    let getProductsURL = encodeURI(`${window.wpApiSettings.root}api/get-products-and-filters/?group-by=name&basic=true&count=12&page=${this.state.activePage}`);
    axios.get(getProductsURL)
      .then(res => {
        const data = res.data.body;
        this.setState({
          products: data.products,
          forcePage: Number(data.currentPage),
          loading: false,
          totalProducts: data.totalProducts,
          activePage: Number(data.currentPage),
          totalPages: data.totalPages,
          totalItemsCount: data.returnedProducts,
          filters: data.basicFilters,
        });
      })
  }

  filterProducts = (type, panels, lines, light, bifold, arctop) => {
    let getProductsURL;
    let baseURL = `${window.wpApiSettings.root}api/get-products-and-filters/?group-by=name`;
    let totalPanels = '';
    let totalLines = '';
    let totalLight = '';

    if (panels) {
      panels.forEach(function (value) {
        totalPanels += `&panels[]=${value}`
      });
      this.setState({totalPanels: totalPanels});
    }
    if (lines) {
      lines.forEach(function (value) {
        totalLines += `&line[]=${value}`
      });
      this.setState({totalLines: totalLines});
    }
    if (light) {
      light.forEach(function (value) {
        totalLight += `&light[]=${value}`
      });
      this.setState({totalLight: totalLight});
    }

    this.setState({
      loading: true,
      type: type,
      totalPanels: totalPanels,
      totalLines: totalLines,
      totalLight: totalLight,
      bifold: bifold,
      arctop: arctop
    }, () => {

      getProductsURL = encodeURI(baseURL + `${this.state.type ? `&type=${this.state.type}` : ''}${this.state.totalPanels}${this.state.totalLines}${this.state.totalLight}${this.state.arctop ? '&arch=1' : ''}${this.state.bifold ? '&bifold=1' : ''}${this.state.firedoor ? '&firedoor=1' : ''}&count=12&page=${this.state.activePage}`)
      axios.get(getProductsURL)
      .then(res => {
        const data = res.data.body;

        this.setState({
          activePage: Number(data.currentPage),
          forcePage: Number(data.currentPage),
          products: data.products,
          loading: false,
          totalProducts: data.totalProducts,
          totalPages: data.totalPages,
          totalItemsCount: data.returnedProducts,
          advancedFilters: data.advancedFilters,
        });
      })
    })
  }

  filterClicked = () => {
    this.setState({ filterClicked: true, activePage: 1 }, () =>
    this.props.history.push({
      pathname: '/products/doors',
      search: `?type=${this.state.type}`
    }));
    scroller.scrollTo('page-title', {
      duration: 500,
      delay: 100,
      smooth: true
    })
  }

  handlePageClick = data => {

    this.setState({
      activePage: data.selected + 1,
      loading: true,
    }, () => {

      if (this.state.filterClicked && this.state.type) {
        this.filterProducts(
          this.state.type,
          this.state.panels,
          this.state.light,
          this.state.lines,
          this.state.bifold,
          this.state.arctop
        )
        this.props.history.push({
          pathname: '/products/doors',
          search: `?type=${this.state.type}&productPage=${this.state.activePage}`
        })
      } else {
        this.props.history.push({
          pathname: '/products/doors',
          search: `?productPage=${this.state.activePage}`
        })
        this.getProducts()
      }
      scroller.scrollTo('page-title', {
        duration: 500,
        delay: 100,
        smooth: true
      })
    })
  };

  activeFilter = (filterType) => {
    let currentFilter = filterType.toLowerCase();
    if(currentFilter === this.state.currentFilter) {
      this.setState({ currentFilter: null });
    } else {
      this.setState({ currentFilter: currentFilter }, () =>
        this.props.history.push({
          pathname: '/products/doors',
          search: "?type=" + this.state.currentFilter
        })
      )
    }
  }

  render() {
    const filters = this.state.filters;

    return (
      <React.Fragment>
        <section className="page-title">
          <div className='container'>
            <div className='row align-items-center'>
              <div className="col-md-12 text-left">
                <div className="text-block__copy" dangerouslySetInnerHTML={{__html: this.state.content}} />
              </div>
            </div>
          </div>
        </section>

        <div className='container'>
          <div className='row'>
            <div className='col-lg-3 col-md-4 products-filters'>
              {this.state.showMoibleFilters && <div className='btn btn--dark' id="toggle-filters" onClick={() => this.setState({mobileFilters: !this.state.mobileFilters})}>Filter Products</div>}
              <div className={`products-filters__inner ${this.state.mobileFilters ? 'active' : ''}`}>
                <div className='btn-group'>
                  <div className='btn btn--green btn-apply' onClick={() => this.setState({mobileFilters: !this.state.mobileFilters})}>Apply</div>
                  <div className='btn btn-close' onClick={() => this.setState({mobileFilters: !this.state.mobileFilters})}>Cancel</div>
                </div>
                <div className='products-filters__inner-scroll'>
                  <div className='filter-title'>
                    <h2>Filter Door Ranges</h2>
                  </div>
                  {filters && Object.keys(filters).map((filter, index) => {
                    let isActive = false;
                    if (this.state.currentFilter && this.state.currentFilter.toLowerCase() === filter.toLowerCase()) {
                      isActive = true;

                    }
                    return (
                      <FilterItem activeFilter={this.activeFilter} filterClicked={this.filterClicked} isActive={isActive}  triggerFilter={this.filterProducts} key={index} name={filter} subCat={filters[filter]} />)
                  }
                  )}
                  {filters &&
                    <div className="reset-btn" onClick={() => this.setState({ activePage: 1, filterClicked: false, }, () => {
                      this.getProducts();
                      this.props.history.push({
                        pathname: '/products/doors',
                        search: ''
                      });
                    })}>
                      <img src={`/wp-content/themes/uniform_base/assets/img/app/reset-btn.svg`} alt="Reset" />
                      Reset All
                    </div>
                  }
                </div>
              </div>
            </div>
            <div className='col-lg-9 col-md-8 products-container'>
              <div className='row align-items-center'>
                <div className='col-lg-6 col-md-6 order-sm-2 text-right'>
                  {/* <div className='search'>
                    <input type='text' placeholder={'Search Products'} />
                  </div> */}
                </div>
                <div className='col-lg-6 col-md-6 order-sm-1'>
                  {this.state.totalProducts > 0 && <h2 className='total-products'><span>{this.state.totalProducts}</span> {this.state.totalProducts > 1 ? 'Products' : 'Product'} for you </h2>}
                </div>
              </div>
              {this.state.loading && <div className='loading-overlay'><img src={`/wp-content/themes/uniform_base/assets/img/app/loader.gif`} alt="img" /></div>}
              <div className='row'>

                {this.state.products.length > 0 ?
                  this.state.products.map(product =>
                    <ProductCard {...product} key={product.sku_code} />
                  ) :
                  !this.state.loading && <div className="no-results">NO PRODUCTS FOUND</div>
                }
              </div>
              <div className='row'>
                <div className='col-lg-12'>
                {this.state.products && this.state.totalProducts > 12 &&
                  <ReactPaginate
                    itemsCountPerPage={this.state.totalItemsCount}
                    totalItemsCount={this.state.totalProducts}
                    pageCount={this.state.totalPages}
                    forcePage={this.state.forcePage - 1}
                    marginPagesDisplayed={document.documentElement.clientWidth < 768 ? 1 : 3}
                    pageRangeDisplayed={document.documentElement.clientWidth < 768 ? 1 : 2}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-link'}
                    activeClassName={'active'}
                    activeLinkClassName={'active'}
                  />
                }
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}


export default Products;
